// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.miholap@celadon.ae>

import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import uuidv4 from 'uuid/v4';
import parse from 'html-react-parser';

import Carousel from 'react-material-ui-carousel';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles';

import { RatingItem } from '../../components';


const RatingBlock = ({
  classes,
  rating_block_title,
  rating_block_description,
  rating_block_carousel_interval,
  rating_panel,
}) => {

  const convertingRateArray = (arr, offset) => {
    const res = [];
    for (let i = 0; i < arr.length; i += offset) {
      res.push(arr.slice(i, i + offset));
    }
    return res;
  };

  const renderCarousel = (offset) => {
    return (
      <Carousel
        interval={rating_block_carousel_interval}
        className={classes.commentsContainer}
      >
        {Array.from(convertingRateArray(rating_panel, offset)).map(arr => (
          <div className={classes.commentInnerContainer}>
            {Array.from(arr).map(el => (
              <RatingItem key={uuidv4()} comment={el.comment} rate={el.rating} />
            ))}
          </div>
        ))}
      </Carousel>
    );
  };

  return (
    <div className={classes.mainContainer}>
      <div className={classes.titleContainer}>
        <h1 className={classes.titleText}>{parse(rating_block_title)}</h1>
        <h4 className={classes.descriptionText}>{parse(rating_block_description)}</h4>
      </div>
      <MediaQuery minWidth={1025}>
        {renderCarousel(3)}
      </MediaQuery>
      <MediaQuery maxWidth={1024} minWidth={768}>
        {renderCarousel(2)}
      </MediaQuery>
      <MediaQuery maxWidth={767}>
        {renderCarousel(1)}
      </MediaQuery>
      <div />
    </div>
  );
};

RatingBlock.propTypes = {
  classes: PropTypes.object,
  rating_block_title: PropTypes.string,
  rating_block_description: PropTypes.string,
  rating_block_carousel_interval: PropTypes.number,
  rating_panel: PropTypes.array,
};

RatingBlock.defaultProps = {
  classes: {},
  rating_block_title: '',
  rating_block_description: '',
  rating_block_carousel_interval: 5000,
  rating_panel: [],
};


export default withStyles(styles)(RatingBlock);
